import { Box, InlineLabel, Switch, Text } from "@prismicio/editor-ui"

import { DocumentListBackButton } from "../app/components/DocumentListBackButton"
import { useHeaderOffset } from "../app/layout/useOffset"
import { routeAnimationDuration, useRepositoryMetaTitle } from "../app/routing"
import { mainContentMaxWidth } from "../document/documentLayout"
import { setLabDarkMode, useLabDarkMode } from "./useLabSettings"

export function Lab() {
  useRepositoryMetaTitle("Lab")

  const { headerOffset } = useHeaderOffset()

  const darkMode = useLabDarkMode()

  return (
    <Box
      position="fixed"
      top={headerOffset}
      display="grid"
      width="100vw"
      animation={{ name: "fadeIn", duration: routeAnimationDuration }}
    >
      <Box justifyContent="center">
        <Box
          flexDirection="column"
          position="relative"
          padding={{ top: 16 }}
          maxWidth={mainContentMaxWidth}
          width="100%"
        >
          <Header />

          <Box flexDirection="column" gap={8} padding={{ top: 48 }}>
            <InlineLabel value="Dark mode">
              <Switch checked={darkMode} onCheckedChange={setLabDarkMode} />
            </InlineLabel>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

function Header() {
  return (
    <Box gap={8} alignItems="center">
      <DocumentListBackButton />
      <Text variant="h1">🧪 Lab Settings</Text>
    </Box>
  )
}
